import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b2abc9a")

_pushScopeId("data-v-7b2abc9a")
const _hoisted_1 = { class: "layout-main tab-space ml-40 nr-40" }
const _hoisted_2 = { class: "main-header" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, undefined, true)
    ]),
    _createVNode("div", {
      class: "main-contents",
      ref: (el) => _ctx.$emit('update:mainEl', el)
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512)
  ]))
})